module.exports = __webpack_public_path__ + "static/media/gap.26e0e59d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/SVGs/gap.svg
// module id = 183
// module chunks = 0